import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../../config';
import { PaginatedUnansweredQuestions } from '../../../../interfaces/unanswered-questions/paginatedStore.type';
import deviceAxios from '../../../../utils/axios/device.axios';

const tryToFetchUnansweredQuestions = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedUnansweredQuestions>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/chatbox/chats/non-relative?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/chats/non-relative?page=${pageNumber}&size=${pageSize}`;
    return deviceAxios.put<PaginatedUnansweredQuestions>(url, data);
};

const tryToFetchAllUnansweredQuestions = (data: any): Promise<AxiosResponse<any>> => {
    const url = data?.filters ?
        `${DEVICE_INFO_API_URL}/chatbox/chats/non-relevant/download?search=${data?.filters}`
        : `${DEVICE_INFO_API_URL}/chatbox/chats/non-relevant/download`
    return deviceAxios.put(url, data?.data);
};

const tryToFetchSingleUnansweredQuestion = (id: string): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/chats/non-relative/${id}`);
};

const tryToFetchUnansweredQuestionStats = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/chatbox/chats/status-trend`);
};

export const UnansweredQuestionsService = {
    tryToFetchUnansweredQuestions,
    tryToFetchAllUnansweredQuestions,
    tryToFetchSingleUnansweredQuestion,
    tryToFetchUnansweredQuestionStats,
};